import { IonReactRouter } from "@ionic/react-router";
import "./global.scss";

import React, { CSSProperties, useEffect } from "react";

import { useLocation, useParams } from "react-router";

import { ScreenOrientation } from '@capacitor/screen-orientation';
import { IonApp, setupIonicReact, useIonRouter } from "@ionic/react";

import { NamedRoute, Redirect, useNamedRoutes } from "./components/NamedRoutes";

import { } from "@ews/react-auth-context";

import Navigation from "./components/Navigation";

import Home from "./pages/Home";

import
{
  System,
  SystemAnalogueValues,
  SystemDetails,
  SystemDisplayDevice,
  SystemDocumentationHistory,
  SystemDocumentationOverlay,
  SystemElementComment,
  SystemElementList,
  SystemEvent,
  SystemEventMemory,
  SystemGroup,
  SystemInputsSystemDocumentation,
  SystemMaintenanceReport,
  SystemOtherAlarmDevices,
  SystemPhonenumber,
  SystemPlan,
  SystemPowerUnitsDocumentation,
  SystemSentTextMessagesLogOverlay,
  SystemSettings,
  //SystemQueries,
  SystemShares,
  SystemShareSettings,
  SystemSpecificationsOverlay,
  SystemTypeDefinitionSubmissionDocuments,
} from "./pages/System";

import { SentNotifications, User, UserSettings } from "./pages/User";

import { L10n, L10nProvider, Locales } from "./setup/locale";

import "./setup/routes";

/* Core CSS required for Ionic components to work properly */
import "@ionic/react/css/core.css";

/* Basic CSS for apps built with Ionic */
import "@ionic/react/css/normalize.css";
import "@ionic/react/css/structure.css";
import "@ionic/react/css/typography.css";

/* Optional CSS utils that can be commented out */
import "@ionic/react/css/display.css";
import "@ionic/react/css/flex-utils.css";
import "@ionic/react/css/float-elements.css";
import "@ionic/react/css/padding.css";
import "@ionic/react/css/text-alignment.css";
import "@ionic/react/css/text-transformation.css";

/* Theme variables */
import { Breakpoints, mobileBreakpoint, ResponsiveProvider } from "./components/Responsive";
import "./theme/variables.css";

import Navbar from "./components/Navigation/Navbar/Main";
import Sidebar from "./components/Navigation/Sidebar/Main";

import { ToolTipProvider } from "./components/ToolTip/useTooltip";

import { ReactData, useWebsocket } from "./components/ReactData/ReactDataProvider";

import { LoadingIndicator } from "./components/Loading";

import
{
  Customer,
  CustomerAddCustomer,
  CustomerAddUser,
  CustomerSettings,
} from "./pages/Customer";

import LoginProvider, {
  AuthInvalid,
  AuthValid,
  useMyProfileId,
  useImpersonationState,
  useImpersonationStateWithSetter,
  useMyProfileIdWithRefresh,
  useMyProfileWithRefresh
} from "./components/Login/LoginProvider";

import { Authorization } from "./components/Authorization";

import LoginPage, {
  ForgotPasswordPage,
  ResetPasswordPage,
} from "./components/Login/LoginPage";

import DeepLink from "./components/DeepLink/Deeplink";

import { RTMDisplay } from "@ews/react-data";
import "@ionic/react/css/ionic-swiper.css";
import "swiper/css";
import { GoogleMapScriptLoader } from "./components/GoogleScriptLoader";
import { setTitle } from "./utils";

import { TermsAndConditionPage, TermsAndConditionsWrapper } from "./components/TermsAndConditionsModal/TermsAndConditionsModal";
import { useChromeKeyboardFix } from "./components/useChromeKeyboardFix";
import { PriceList, PriceListSetting } from "./pages/PriceList";
import { useL10n } from "@ews/react-localization-context";
import { ReactTopics } from "@ews/websocket-service";


type Children = {
  children?: React.ReactNode;
};

setupIonicReact();

export const useCurrentLocale = () =>
{
  const router = useIonRouter();
  const route = router.routeInfo.pathname.match(/^\/(?<locale>[^/]+)(\/.*)?/);
  return route?.groups?.locale || Locales.default;
};

const TranslationWrapper = ({ children }: Children) =>
{
  const locale = useCurrentLocale();//useParams<{ locale?: string; }>();
  const location = useLocation();

  L10nProvider.setLocale(locale || Locales.default);

  if (location.search.includes("dev=1")) {
    L10nProvider.setTestMode();
  }

  return (
    <L10n provider={L10nProvider} autoCapture={false}>
      {children}
    </L10n>
  );
};

const NavigationWrapper = ({ children }: Children) =>
{
  return (
    <Navigation navbar={Navbar} sidebar={Sidebar} id="main">
      {children}
    </Navigation>
  );
};

const PageWrapper = ({ children }: Children) =>
{
  const params = useParams<{ locale?: string; }>();
  L10nProvider.setLocale(params.locale || Locales.default);

  return (

    <NavigationWrapper>{children}</NavigationWrapper>

  );
};
const OrientationWrapper = ({ children }: Children) =>
{

  useEffect(() =>
  {
    const { height, width } = window.screen;

    const breakpoint = Breakpoints[mobileBreakpoint];

    const isHeightMobile = height < breakpoint;
    const isWidthMobile = width << breakpoint;

    const lockOrientation = async () =>
    {
      try {
        await ScreenOrientation.lock({ orientation: "portrait-primary" });
      } catch (error) {
      }
    };
    if (isHeightMobile && isWidthMobile) {

      lockOrientation();
    }

  }, []);

  return <>{children}</>;

};



const AuthComponentWrapper = ({ children }: Children) =>
{
  const { component, rest } = useParams<{
    component?: string;
    rest?: string;
  }>();

  switch (component) {
    case "forgot-password":
      return (

        <ForgotPasswordPage />

      );

    case "reset-password":
      return (

        <ResetPasswordPage token={rest} />

      );

    default:
      return (

        <LoginPage />

      );
  }
};


const simulationStatusContainerStyle = {
  position: "fixed",
  top: 0,
  right: "6.75em",

  zIndex: 999999,

  border: "5px double orange",
  boxSizing: "border-box",
  background: "white",

  padding: "0.25em 1em",
  marginTop: "0.66em",

  display: "inline-block",
  whiteSpace: "nowrap",
  opacity: "50%"
} satisfies CSSProperties;

const simulationStatusTextStyle = {
  color: "orange",
  fontWeight: "bold",
  textTransform: "uppercase",
} satisfies CSSProperties;

function SimulationHint()
{
  const impersonationState = useImpersonationState();
  const { impersonationStatus } = impersonationState;
  const { translate: t, getLocale } = useL10n();

  let simulationHint = impersonationStatus === "ending" ?
    [
      <span style={simulationStatusTextStyle} key="sim-end">
        {t("[REACT_SIMULATION_ENDING]")}
      </span>
    ]
    : impersonationStatus === "in-progress" ?
      [
        <span style={simulationStatusTextStyle} key="sim-start">
          {t("[REACT_SIMULATION_STARTING]")}
        </span>
      ]

      : impersonationStatus !== "inactive" ?
        [
          <span style={simulationStatusTextStyle} key="sim-active">
            {t("[REACT_SIMULATION_ACTIVE]")}
          </span>
        ]
        : null;


  if (simulationHint && "impersonatedUserFirstName" in impersonationState) {
    simulationHint.push(
      <span key="sim-name">
        &nbsp;{`${impersonationState.impersonatedUserFirstName} ${impersonationState.impersonatedUserLastName}`}
      </span>
    );
  }

  return (
    simulationHint ?
      <div style={simulationStatusContainerStyle}>
        {simulationHint}
      </div>
      : null
  );
}



const App: React.FC = () =>
{
  useChromeKeyboardFix();

  setTitle();

  return (
    <IonApp>
      <ReactData>
        <ResponsiveProvider>
          <OrientationWrapper>
            {/* <NetworkStatus></NetworkStatus> */}
            {/* <AuthorizationStatus></AuthorizationStatus> */}
            <LoadingIndicator>
              <ToolTipProvider>
                <IonReactRouter>
                  <TranslationWrapper>
                    <DeepLink />

                    <LoginProvider>
                      <AuthInvalid>
                        <NamedRoute name="auth-component">
                          <AuthComponentWrapper />
                        </NamedRoute>
                      </AuthInvalid>
                      <AuthValid>
                        <TermsAndConditionsWrapper>

                          <NamedRoute name="guide-lines">
                            <TermsAndConditionPage />
                          </NamedRoute>

                          <Authorization>
                            <SimulationHint />
                            <GoogleMapScriptLoader >

                              <NamedRoute name="home-default">
                                <Redirect to="/" />
                              </NamedRoute>

                              <NamedRoute name="home">
                                <PageWrapper>
                                  <Home />
                                </PageWrapper>
                              </NamedRoute>


                              <NamedRoute name="systems">
                                <System />
                              </NamedRoute>

                              <NamedRoute name="system:events">
                                <SystemEvent />
                              </NamedRoute>

                              <NamedRoute name="system:events-page2">
                                <SystemEvent eventTab={RTMDisplay.eventsTab2} />
                              </NamedRoute>

                              <NamedRoute name="system">
                                <SystemDetails />
                              </NamedRoute>

                              <NamedRoute name="system:plan">
                                <SystemPlan />
                              </NamedRoute>

                              <NamedRoute name="system:settings">
                                <SystemSettings />
                              </NamedRoute>

                              <NamedRoute name="system:elements">
                                <SystemGroup />
                              </NamedRoute>

                              <NamedRoute name="system:element-comment">
                                <SystemElementComment />
                              </NamedRoute>

                              <NamedRoute name="system:maintenancereport">
                                <SystemMaintenanceReport />
                              </NamedRoute>

                              <NamedRoute name="system:eventmemory">
                                <SystemEventMemory />
                              </NamedRoute>

                              <NamedRoute name="system:analoguevalues">
                                <SystemAnalogueValues />
                              </NamedRoute>

                              {/* <NamedRoute name="system:queries" >

                        <SystemQueries />

                    </NamedRoute> */}

                              <NamedRoute name="system:shares">
                                <SystemShares />
                              </NamedRoute>

                              <NamedRoute name="system:share-settings">
                                <SystemShareSettings />
                              </NamedRoute>

                              <NamedRoute name="system:phonenumber">
                                <SystemPhonenumber />
                              </NamedRoute>

                              <NamedRoute name="system:documentationhistory">
                                <SystemDocumentationHistory />
                              </NamedRoute>

                              <NamedRoute name="system:displaydevice">
                                <SystemDisplayDevice />
                              </NamedRoute>

                              <NamedRoute name="system:powerunitsDocumentation">
                                <SystemPowerUnitsDocumentation />
                              </NamedRoute>

                              <NamedRoute name="system:elementslist">
                                <SystemElementList />
                              </NamedRoute>

                              <NamedRoute name="system:otheralarmdevices">
                                <SystemOtherAlarmDevices />
                              </NamedRoute>

                              <NamedRoute name="system:otherdevices">
                                <SystemOtherAlarmDevices />
                              </NamedRoute>

                              <NamedRoute name="system:inputssystemDocumentation">
                                <SystemInputsSystemDocumentation />
                              </NamedRoute>

                              <NamedRoute name="system:submissiondocuments">
                                <SystemSpecificationsOverlay />
                              </NamedRoute>

                              {/* <NamedRoute name="system:specifications" >

                            <SystemSpecificationsOverlay />

                        </NamedRoute> */}

                              <NamedRoute name="system:documentation">
                                <SystemDocumentationOverlay />
                              </NamedRoute>

                              <NamedRoute name="system:typedefinition-submission-documents">
                                <SystemTypeDefinitionSubmissionDocuments />
                              </NamedRoute>

                              <NamedRoute name="system:sent-text-messages-log">
                                <SystemSentTextMessagesLogOverlay />
                              </NamedRoute>

                              <NamedRoute name="users">
                                <User />
                              </NamedRoute>

                              <NamedRoute name="user">
                                <UserSettings />
                              </NamedRoute>
                              <NamedRoute name="user:sent-notifications-log">
                                <SentNotifications />
                              </NamedRoute>

                              <NamedRoute name="customers">
                                <Customer />
                              </NamedRoute>

                              <NamedRoute name="customer:customers">
                                <Customer filterByCustomer />
                              </NamedRoute>

                              <NamedRoute name="customer">
                                <CustomerSettings />
                              </NamedRoute>

                              <NamedRoute name="customer:addcustomer">
                                <CustomerAddCustomer />
                              </NamedRoute>

                              <NamedRoute name="customer:adduser">
                                <CustomerAddUser />
                              </NamedRoute>

                              <NamedRoute name="system:addsystem">
                                <SystemSettings />
                              </NamedRoute>

                              <NamedRoute name="customer:systems">
                                <System filterByCustomer />
                              </NamedRoute>

                              <NamedRoute name="customer:users">
                                <User filterByCustomer />
                              </NamedRoute>

                              <NamedRoute name="priceLists">
                                <PriceList />
                              </NamedRoute>

                              <NamedRoute name="priceList">
                                <PriceListSetting />
                              </NamedRoute>

                              <NamedRoute name="reset-password">
                                <ResetPasswordPage />
                              </NamedRoute>

                              {/* <NamedRoute name="debug">

                            <Debug />

                        </NamedRoute> */}
                            </GoogleMapScriptLoader>
                          </Authorization>
                        </TermsAndConditionsWrapper>
                      </AuthValid>
                    </LoginProvider>
                  </TranslationWrapper>
                </IonReactRouter>
              </ToolTipProvider>
            </LoadingIndicator>
          </OrientationWrapper>
        </ResponsiveProvider>
      </ReactData>
    </IonApp >
  );
};

export default App;
